export default {"src":"/_next/static/media/moac.31887482.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};